<template>
	<div>
		<hnx-spinner></hnx-spinner>
	</div>
</template>

<script>
import { loginProvider, spinner } from '@/hnx/hnx';

export default {
	data() {
		return {
			loginProvider
		};
	},

	created() {
		spinner.show();
		const hash = window.location.hash.substr(1) || '/redirect';
		
		loginProvider.currentUser()
			.then((userData) => {
				if (userData === null) {
					window.location.replace(`/login.html?redirect=${hash}`);
				} else {
					window.location.replace(`/main.html#${hash}`);
				}
			})
			.catch(() => {
				window.location.replace(`/login.html?redirect=${hash}`);
			});
	},
};
</script>
